import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_pt_BR.min.js';
import {getCookie} from './common/cookie-handler.js';


( function ( $ ) {
    'use strict';
    const host_origin = window.location.origin;

    const validation_endpoints = {
        'pre_login': `${host_origin}/accounts/auth/validate/`,
    };

    function getCookie(name) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
    const csrftoken = getCookie('csrftoken');

    const serverPath = '';
    let loginFormHTML;
    let loginFormParent;
    let signupFormHTML;
    let signupFormParent;
    let recoveryFormHTML;
    let recoveryFormParent;

    let recurrentElements = {
        'login-email-field': $("#login-email"),
        'login-password-field': $("#login-password"),
        'signup-name-field': $("#signup-name"),
        'signup-birthday-field': $("#signup-birthday"),
        'signup-email-field': $("#signup-email"),
        'signup-password-field': $("#signup-password"),
        'signup-password2-field': $("#signup-password2"),
        'recovery-email-field': $("#recovery-email"),
        'recovery-birthday-field': $("#recovery-birthday")
    };


    // Backend variable for controlling error message exhibition, not allowing errors upon
    // form population if the form's latest submit attempt was not made with errors
    let formErrorMsg = false;

    // Function enclosing possible field validation rules of each auth form. Returns a object.
    const getFormValidationRule = function(form) {
        let headers = {"X-CSRFToken": getCookie("csrftoken")},
            formPrefix = form.id.split('-')[0],
            rule = {},
            checkUserExistsRule = function (form_id) {
                return {
                    remote: {
                        url: validation_endpoints['pre_login'],
                        headers: headers,
                        type: 'post',
                        dataType: 'json',
                        data: {
                            'email': function() {return $(recurrentElements[`${formPrefix}-email-field`]).val();},
                            'origin': form_id,
                        },
                        xhrFields: {
                            withCredentials: true
                        },
                        complete: function (data) {
                            checkShowAuthErrorMsgOnly(form, data);
                        }
                    }}
            },
            checkUserPasswordRule = function(form_id) {
                return {
                    remote: {
                        url: validation_endpoints['pre_login'],
                        headers: headers,
                        type: 'post',
                        dataType: 'json',
                        data: {
                            'email': function() {return $(recurrentElements[`${formPrefix}-email-field`]).val();},
                            'password': function() {return $(recurrentElements[`${formPrefix}-password-field`]).val();},
                            'origin': form_id,
                        },
                        xhrFields: {
                            withCredentials: true
                        },
                        complete: function (data) {
                            checkShowAuthErrorMsgOnly(form, data);
                        }
                    }
                }
            };

        switch (form.id) {
            case 'login-form':
                rule['login-email'] = checkUserExistsRule(form.id);
                rule['login-password'] = checkUserPasswordRule(form.id);
                break;

            case 'signup-form':
                rule['signup-email'] = checkUserExistsRule(form.id);
                rule['signup-password2'] = {equalTo: '#signup-password'};
                break;

            case 'recovery-account-form':
                rule['recovery-email'] = checkUserExistsRule(form.id);
                break;
        }
        return rule;
    };

    // Toggles the exibition of authentication error message above given auth form
    const formMsgWrapperHandler = function(form, turnVisible, {changeVar = true, fieldErrorsHTML = null} = {}) {
        let formMsgWrapper = $(form).find('.message-wrapper');
        let fieldErrorWrapper = $(form).find('.field-error-wrapper');

        let validator = $(form).data('validator');
        let errorFieldsQty = (validator && typeof validator.numberOfInvalids === 'function') ? validator.numberOfInvalids() : 0;

        if (formErrorMsg && errorFieldsQty > 0) {
            loadingLogosOff();
            return;
        }

        if (turnVisible) {
            // Only toggle visibility, don't change .message-wrapper text
            formMsgWrapper.addClass('d-flex');

            if (fieldErrorsHTML !== null) {
                fieldErrorWrapper.html(fieldErrorsHTML);
            }
            fieldErrorWrapper.addClass('d-flex');

            if (changeVar) {
                formErrorMsg = true;
            }
            return;
        }

        // Hide both and clear only the field errors
        formMsgWrapper.removeClass('d-flex');
        fieldErrorWrapper.removeClass('d-flex').html('');

        if (changeVar) {
            formErrorMsg = false;
        }
    };


    // Calls formMsgWrapperHandler accordingly after remote validation without changing backend variable
    const checkShowAuthErrorMsgOnly = function (form, data) {

        data.responseJSON === true ?
            $(form).data('validator').numberOfInvalids() > 0 ?
                formMsgWrapperHandler(form, true, {changeVar: false}) :
                formMsgWrapperHandler(form, false, {changeVar: false})
            : formMsgWrapperHandler(form, true, {changeVar: false})
    };

    // Persists relevant populated fields between auth forms
    const swapFormDataHandler = function(form) {
        let login_email = recurrentElements['login-email-field'],
            login_password = recurrentElements['login-password-field'],
            signup_email = recurrentElements['signup-email-field'],
            signup_password = recurrentElements['signup-password-field'],
            recovery_email = recurrentElements['recovery-email-field'];

        switch (form.id) {
            case 'login-form':
                $(signup_email).val(login_email.val());
                $(signup_password).val(login_password.val());
                break;

            case 'signup-form':
                // Workaround for login cases coming from recovery form
                let emailReplacement;
                if (signup_email.val() !== '') {
                    emailReplacement = signup_email.val();
                }
                if (recovery_email.val() !== '') {
                    emailReplacement = recovery_email.val();
                }
                $(login_email).val(emailReplacement);
                $(login_password).val(signup_password.val());
                break;

            case 'recovery-account-form':
                $(recovery_email).val(login_email.val());
                break;
        }
    };

    // Manages the correct form exhibition
    const swapFormExhibitionHandler = function (form) {
        switch (form.id) {
            case 'login-form':
                loginForm.parentElement.classList.add('d-flex');
                signupForm.parentElement.classList.remove('d-flex');
                recoveryForm.parentElement.classList.remove('d-flex');

                swapLogin.parentElement.classList.remove('d-flex');
                swapSignUp.parentElement.classList.add('d-flex');
                break;

            case 'signup-form':
                loginForm.parentElement.classList.remove('d-flex');
                signupForm.parentElement.classList.add('d-flex');
                recoveryForm.parentElement.classList.remove('d-flex');

                swapLogin.parentElement.classList.add('d-flex');
                swapSignUp.parentElement.classList.remove('d-flex');
                break;

            case 'recovery-account-form':
                loginForm.parentElement.classList.remove('d-flex');
                signupForm.parentElement.classList.remove('d-flex');
                recoveryForm.parentElement.classList.add('d-flex');

                swapLogin.parentElement.classList.add('d-flex');
                swapSignUp.parentElement.classList.remove('d-flex');
                break;
        }
    };

    // Clean the given form data and validations
    const cleanUpFormHandler = function(form) {
        $(form).each(function () {
            $(this).data('validator').resetForm();
            $(this).get(0).reset();
            formMsgWrapperHandler(form, false);
        });
    };

    $('[data-src="#signup-login-modal"]').fancybox({
        baseClass: 'signup-login-modal-wrapper'
    });

    function formatToDDMMYYYY(isoDateStr) {
        if (!isoDateStr) return '';
        const [year, month, day] = isoDateStr.split('-');
        return `${year}-${month}-${day}`;
    }

    // FORMS DE AUTENTICACAO
    $('.auth-form').each(function () {
        const $form = $(this);

        $form.validate({
            onkeyup: false,
            onfocusout: false,
            onclick: false,
            focusInvalid: false,

            rules: getFormValidationRule($form[0]),

            errorElement: 'div',
            errorPlacement: function (error, element) {
                error.addClass('invalid-feedback');
                element.closest('.form-floating').after(error);
            },
            highlight: function (element) {
                $(element).addClass('is-invalid');
            },
            unhighlight: function (element) {
                $(element).removeClass('is-invalid');
            },

            submitHandler: function (form) {
                formMsgWrapperHandler(form, false);

                switch (form.id) {
                    case 'login-form': {
                        const login_email = $(recurrentElements['login-email-field']).val();
                        const login_password = $(recurrentElements['login-password-field']).val();

                        authLogin(login_email, login_password)
                            .then(loginResponse => processLogin(loginResponse, form));
                        break;
                    }

                    case 'signup-form': {
                        const signup_name = $(recurrentElements['signup-name-field']).val();
                        let signup_birthday = $(recurrentElements['signup-birthday-field']).val();
                        const signup_email = $(recurrentElements['signup-email-field']).val();
                        const signup_password = $(recurrentElements['signup-password-field']).val();
                        const signup_password2 = $(recurrentElements['signup-password2-field']).val();

                        signup_birthday = formatToDDMMYYYY(signup_birthday);

                        authSignUp(signup_name, signup_birthday, signup_email, signup_password, signup_password2)
                            .then(data => processSignUp(data, form));
                        break;
                    }

                    case 'recovery-account-form': {
                        const recover_email = $(recurrentElements['recovery-email-field']).val();
                        let recover_birthday = $(recurrentElements['recovery-birthday-field']).val();

                        recover_birthday = formatToDDMMYYYY(recover_birthday);

                        authRecover(recover_email, recover_birthday)
                            .then(data => console.log(data));
                        break;
                    }

                    default:
                        console.log("Case not implemented");
                }
            },

            invalidHandler: function (event, validator) {
                formMsgWrapperHandler($form[0], true);
            }
        });
    });

    // Calls cleanUpFormHandler for cleaning all authentication forms
    $(document).on('beforeClose.fb', function (e, instance, slide) {
        $('.auth-form').each(function () {
            cleanUpFormHandler($(this)[0])
        });
    });




    /** *********************************************************************************************************** **/
    /** *********************************************************************************************************** **/
    /** **************************************AUTHENTICATION PROCESSING******************************************** **/
    /** *********************************************************************************************************** **/
    /** *********************************************************************************************************** **/
    const processLogin = function(data, form, {loading=false} = {}) {
        if (loading) {
            loginFormParent = loginForm.parentElement;
            loginFormHTML = loginFormParent.innerHTML;

            loginForm.classList.remove('d-flex');
            return;
        }

        if (!data) {
            return
        }

        // Authentication Failed
        if (!data.hasOwnProperty('access')) {
            const credentialError_enUS = "Unable to log in with provided credentials.";
            const credentialError_ptBR = "Não foi possível realizar o login com as credenciais fornecidas.";

            loginForm.classList.add('d-flex');

            // Auth error due to invalid credentials
            if (data.non_field_errors && (data.non_field_errors.includes(credentialError_enUS)) || data.non_field_errors.includes(credentialError_ptBR)) {
                formMsgWrapperHandler(form, true);
                // Untracked auth errors
            } else {
                console.log("Something went wrong. Please try again later.")
            }
            return;
        }

        // Authentication Successful
        document.location.reload();
    };


    const processSignUp = function(data, form) {
        if (!data) return;

        // Clear previous errors
        form.querySelectorAll('.invalid-feedback').forEach(el => el.remove());
        form.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid'));
        formMsgWrapperHandler(form, false);

        // Always stop loading spinner
        loadingLogosOff();

        // Registration failed
        if (!data.hasOwnProperty('access')) {
            let fieldErrorsHTML = '';

            for (const field in data) {
                if (!data.hasOwnProperty(field)) continue;

                const rawMessages = data[field];
                const messages = Array.isArray(rawMessages) ? rawMessages.join(' ') : rawMessages;

                const input = form.querySelector(`[name="${field}"]`);

                if (input) {
                    input.classList.add('is-invalid');

                    const errorEl = document.createElement('div');
                    errorEl.className = 'invalid-feedback';
                    errorEl.innerText = messages;

                    // Insert error element appropriately
                    if (
                        input.parentElement.classList.contains('form-group') ||
                        input.parentElement.classList.contains('input-group')
                    ) {
                        input.parentElement.appendChild(errorEl);
                    } else {
                        input.insertAdjacentElement('afterend', errorEl);
                    }
                } else if (field === 'non_field_errors') {
                    // Instead of setting message (which you want to keep untouched),
                    // accumulate these messages into fieldErrorsHTML
                    // So show non_field_errors inside field-error-wrapper as well
                    if (Array.isArray(rawMessages)) {
                        rawMessages.forEach(msg => {
                            fieldErrorsHTML += `
                                <div style="color: red;">
                                    <ion-icon name="alert-circle-outline"></ion-icon> ${msg}
                                </div>`;
                        });
                    } else {
                        fieldErrorsHTML += `
                            <div style="color: red;">
                                <ion-icon name="alert-circle-outline"></ion-icon> ${rawMessages}
                            </div>`;
                    }
                } else {
                    if (Array.isArray(rawMessages)) {
                        rawMessages.forEach(msg => {
                            fieldErrorsHTML += `
                                <div style="color: red;">
                                    <ion-icon name="alert-circle-outline"></ion-icon> ${msg}
                                </div>`;
                        });
                    } else {
                        fieldErrorsHTML += `
                            <div style="color: red;">
                                <ion-icon name="alert-circle-outline"></ion-icon> ${rawMessages}
                            </div>`;
                    }
                }
            }

            if (fieldErrorsHTML) {
                formMsgWrapperHandler(form, true, { fieldErrorsHTML });
            }
            return;
        }

        // Registration successful
        document.location.reload();
    };


    /** *********************************************************************************************************** **/
    /** *********************************************************************************************************** **/
    /** **************************************AUTHENTICATION REQUESTS CODE***************************************** **/
    /** *********************************************************************************************************** **/
    /** *********************************************************************************************************** **/
    const authLogin = function(email, password) {
        const data = {email: email, password: password};
        processLogin('', {loading: true});
        const response = fetch(`${serverPath}accounts/auth/login/`, {
            method: 'post',
            headers: new Headers({'Content-Type': 'application/json'}),
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(function(data){
                console.log(data);
                loadingLogosOff();
                return data;
            });
        return response;
    };


    const authSignUp = function(name, birthday, email, password, password2) {
        const data = {name: name, birthday: birthday, email: email, password1: password, password2: password2};
        const response = fetch(`${serverPath}accounts/auth/registration/`, {
            method: 'post',
            headers: new Headers({'Content-Type': 'application/json'}),
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(function(data) {
                console.log(data);
                loadingLogosOff();
                return data;
            });
        return response;
    };


    const authRecover = function(email, birthday) {
        const data = {birthday: birthday, email: email};
        fetch(`${serverPath}accounts/auth/password/reset/`, {
            method: 'POST',
            headers: new Headers({'Content-Type': 'application/json', 'X-CSRFToken': csrftoken}),
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then((data) => {
                console.log(data);
                loadingLogosOff();
            })
    };
    /** *********************************************************************************************************** **/
    /** *********************************************************************************************************** **/
    /** **************************************AUTHENTICATION REQUESTS CODE***************************************** **/
    /** *********************************************************************************************************** **/
    /** *********************************************************************************************************** **/


    /** *********************************************************************************************************** **/
    /** *********************************************************************************************************** **/
    /** **************************************FRONTEND AUTH FORMS HANDLING***************************************** **/
    /** *********************************************************************************************************** **/
    /** *********************************************************************************************************** **/
        // Login Code
    const loginForm = document.getElementById('login-form');
    loginForm.addEventListener('submit', function(event) {
        event.preventDefault();
        if(loginForm.checkValidity()) {
            loadingLogos();
        }
    });

    // Registration Code
    const signupForm = document.getElementById('signup-form');
    signupForm.addEventListener('submit', function(event) {
        event.preventDefault();
        if(signupForm.checkValidity()) {
            loadingLogos();
        }
    });

    // Recovery Code
    const recoveryForm = document.getElementById('recovery-account-form');
    recoveryForm.addEventListener('submit', function(event) {
        event.preventDefault();
        if(recoveryForm.checkValidity()) {
            loadingLogos();
        }
    });


    /** Swapping Between Auth Forms **/
    const swapLogin = document.getElementById('swap-login');
    const swapSignUp = document.getElementById('swap-signup');
    const swapRecovery = document.getElementById('swap-recovery');

    const ctaSignUp = document.getElementById('cta-signup');
    const hdrLogin = document.getElementById('hdr-login');

    const signUpFormHandler = function() {
        swapFormDataHandler(loginForm);
        cleanUpFormHandler(loginForm);
        swapFormExhibitionHandler(signupForm);
    };

    const loginFormHandler = function () {
        swapFormDataHandler(signupForm);
        cleanUpFormHandler(signupForm);
        cleanUpFormHandler(recoveryForm);
        swapFormExhibitionHandler(loginForm);
    };

    hdrLogin.addEventListener('click', function (event) {
        event.preventDefault();
        if (window.location.pathname === '/') {
            loginFormHandler();
        } else {
            window.location.href = '/login';
        }
    });

    ctaSignUp.addEventListener('click', function(event) {
        event.preventDefault();
        signUpFormHandler();
    });

    swapSignUp.addEventListener('click', function(event) {
        event.preventDefault();
        signUpFormHandler();
    });

    swapLogin.addEventListener('click', function(event) {
        event.preventDefault();
        loginFormHandler();
    });

    swapRecovery.addEventListener('click', function(event) {
        event.preventDefault();
        swapFormDataHandler(recoveryForm);
        cleanUpFormHandler(loginForm);
        swapFormExhibitionHandler(recoveryForm);

    });
    /** *********************************************************************************************************** **/
    /** *********************************************************************************************************** **/
    /** **************************************FRONTEND AUTH FORMS HANDLING***************************************** **/
    /** *********************************************************************************************************** **/
    /** *********************************************************************************************************** **/

    const loadingLogos = function() {
        let logos = document.querySelectorAll(".modal-logo")
        logos.forEach(logo => {
            logo.classList.add('pulsator');
        })

        let spinners = document.querySelectorAll('.loading-spin');
        spinners.forEach(spinner => {
            spinner.classList.remove('d-none');
        })
    }

    const loadingLogosOff = function() {
        let logos = document.querySelectorAll(".modal-logo")
        logos.forEach(logo => {
            logo.classList.remove('pulsator');
        })

        let spinners = document.querySelectorAll('.loading-spin');
        spinners.forEach(spinner => {
            spinner.classList.add('d-none');
        })
    }

}(jQuery));


// $(":submit").click(function(event){
//     switch($(this).attr("id")){
//         case "signup-submit":
//             event.preventDefault();
//             const endpoint = "api/auth/registration/";
//             const method = 'post';
//             var data = {
//                 //name : $("#signup-name").val(),
//                 email : $("#signup-email").val(),
//                 //birthday : $("#signup-birthday").val(),
//                 password1 : $("#signup-password").val(),
//                 password2 : $("#signup-password2").val()
//             };
//
//             const response = fetch(endpoint);
//             response.then(function(msg) {
//                 console.log(msg);
//             });
//
//             break;
//         case "login-submit":
//             // code
//             break;
//         case "recovery-submit":
//             // code
//             break;
//         default:
//             alert("Default action");
//     }
// });